import { LGraphNode, LiteGraph } from "litegraph.js";

/**
 * MaskNode
 * --------
 * Uses one canvas as an alpha mask for another.
 * The mask's brightness determines the output opacity.
 */
export class MaskNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Mask";

    this.properties = {
      invert: false,
    };

    this.addInput("Source", "canvas");
    this.addInput("Mask", "canvas");
    this.addOutput("Canvas", "canvas");

    this.addWidget("toggle", "Invert", false, (val) => {
      this.properties.invert = val;
    });

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 70];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    const source = this.getInputData(0);
    const mask = this.getInputData(1);
    if (!source) { this.setOutputData(0, null); return; }

    const w = source.width;
    const h = source.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    ctx.clearRect(0, 0, w, h);

    if (!mask) {
      ctx.drawImage(source, 0, 0);
      this.setOutputData(0, this._outCanvas);
      return;
    }

    // Draw mask first — we'll use its luminance as alpha
    ctx.drawImage(mask, 0, 0, w, h);
    const maskData = ctx.getImageData(0, 0, w, h);

    // Draw source
    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(source, 0, 0);
    const srcData = ctx.getImageData(0, 0, w, h);

    // Apply mask brightness as alpha
    const inv = this.properties.invert;
    for (let i = 0; i < srcData.data.length; i += 4) {
      let brightness = (maskData.data[i] * 0.299 + maskData.data[i + 1] * 0.587 + maskData.data[i + 2] * 0.114) / 255;
      if (inv) brightness = 1 - brightness;
      srcData.data[i + 3] = Math.round(srcData.data[i + 3] * brightness);
    }

    ctx.putImageData(srcData, 0, 0);
    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("composite/Mask", MaskNode);
